import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateCurrentUser } from "actions";

export function useAuth() {
  const history = useHistory();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

  useEffect(() => {
    let unlisten = null;
    if (!isAuthenticated) {
      history.push("/");
    } else {
      dispatch(updateCurrentUser());
      unlisten = history.listen(() => {
        window.scrollTo(0, 0);
      });
    }
    return () => {
      if (unlisten) {
        unlisten();
      }
    };
  }, [isAuthenticated]);

  return isAuthenticated;
}
